module.exports = "/_next/static/images/img-mobile-hiring-faces-top-d52c492cefd9ba2773c7d1a5aeb190bd.png";